
import request from "../utils/request";


export function getActionList(query) {
  return request.get('/jiulong/jsList', {params: query})
}

export function getWxToken() {
  return request.get('/jiulong/getToken')
}


export function sendAction(body) {
  return request.post("/jiulong/add", body)
}

export function login(body) {
  return request.post('/jiulong/login', body)
}
